import Vue from 'vue'
import App from './App.vue'
import store from './store'
import userConfig from '@config'
import installGlobalComponent from '@components/global'
import installApis from '@http'
import installUtils from '@utils/index.js'
import * as filters from '@/filters'
import installSensors from '@/sensors/index.js'
import installMock from '@/mock'
// import installVconsole from '@/vconsole/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import ClientMonitor from 'skywalking-client-js';
// installVconsole(Vue)
Vue.use(ElementUI);

userConfig(Vue)
installApis(Vue)
installUtils(Vue)
installSensors(Vue)
installGlobalComponent(Vue)

// 单独使用一个vue实例没有dom数据较轻
Vue.prototype.$EventBus = new Vue()

Vue.config.productionTip = false

Vue.prototype.$browserEnv = Vue.prototype.$utils.getRunBrowser()
if (Vue.prototype.$browserEnv==1) {
  Vue.prototype.$wk = Vue.prototype.$utils.judgeWK()
}
/**
 * 路由守卫
 */
// router.beforeEach((to, from, next)=> {
//   window.scrollTo(0,0);
//   if (to.meta.title) {
    
//     document.title = to.meta.title ? to.meta.title : ''
    
//     // 兼容iphone手机title不会改变
//     if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
//       var i = document.createElement('iframe');
//       i.style.display = 'none';
//       i.onload = function() {
//           setTimeout(function(){
//               i.remove();
//           }, 17)
//       }
//       document.body.appendChild(i);
//     }
//   }
//   next()
// })

/**
 * 生产环境才启动mock模块
 */
if (process.env.NODE_ENV === 'development') {
  installMock()
}

/**
 * 挂载全局过滤器
 */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// Vue.prototype.$utils.getVueQuery()
// Vue.prototype.$utils.judgeUrl()
async function init () {
  let q = ''
  let pcLocate = ''
  

  try {
    q = await Vue.prototype.$utils.judgeUrl()
    pcLocate = Vue.prototype.$utils.getCookie('pcLocate')
    pcLocate = pcLocate ? JSON.parse(pcLocate) : ''
  } catch (error) {
    // console.log();
  }finally {
    Vue.prototype.$global = {
      q: q || "", // 搜索词
      tab: {text: '综合', title: 'auto_index', id: 1}, //当前tab
      tabLists: [
          {text: '综合', title: 'auto_index', id: 1},
          {text: '文章', title: 'auto_cms', id: 2},
          {text: '论坛', title: 'auto_bbs', id: 3},
          {text: '视频', title: 'auto_video', id: 4},
          {text: '百科', title: 'auto_baike', id: 5},
          {text: '图片', title: 'picture', id: 6},
          {text: '经销商', title: 'dealers', id: 7},
          {text: '车问答', title: 'carQa', id: 8},
          {text: '太平洋号', title: 'auto_hj', id: 9},
    ],
      video: Vue.prototype.$utils.getUrlQuery('auto_video') || "", //判断url参数,跳转到对应的页面
      qType: 0,
      enableHomonyn: Vue.prototype.$utils.getUrlQuery('enableHomonyn') || true, //是否使用同音词
      rid: Vue.prototype.$utils.getCookie('PClocation') || 1, //城市id-默认广州
      cityCode: pcLocate.cityCode || '',
  }
  
  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app')
  
  }
}
init()


/**
 * skywalking日志上报
 */
 if (process.env.VUE_APP_NODE_ENV === 'production') {
  // 1.配置信息
  const configs = {
    collector: 'https://auto-c.pcauto.com.cn',
    service: 'kuaisou-pc-ui',
    vue: Vue,
    useFmp: true,
    pagePath: location.href,
    serviceVersion: 'v1.0.1',
    jsErrors: true,
    apiErrors: true,
    resourceErrors: true,
    autoTracePerf: true,
    detailMode: true,
    traceTimeInterval: 2000,
  }
  // 2.注册
  ClientMonitor.register(configs)
  // 3.性能信息上报
  ClientMonitor.setPerformance(configs)
  // 4.vue错误信息上报
  Vue.config.errorHandler = (error) => {
    ClientMonitor.reportFrameErrors(configs, error)
  }
}